import { InjectionToken } from '@angular/core';

const NAMESPACE = 'gt_';

/** Minutes the client gets to pay a booking — or whatever was just added to it — before it expires. */
export const BOOKING_PAYMENT_WINDOW_MINUTES = 30;

export const COLLECTIONS = {
  USERS: 'users',
  USERS_PHOTOS: 'user_photos',
  USER_PREFERENCES: 'user_preferences',
  MASTERS: 'masters',
  MASTERS_SETTINGS_DOC: 'settings',
  MASTERS_CATEGORIES_DOC: 'categories',
  SCHEDULED_EMAILS: 'scheduled_emails',
  NOTIFICATIONS: 'notifications',
  NOTIFICATIONS_TEMPLATES: 'notifications_templates',
  INSCRIPTIONS: NAMESPACE + 'inscriptions',
  INSCRIPTIONS_ORGANIZATION: 'organization',
  INSCRIPTIONS_FORMS: 'forms', // Subcollection dentro de inscriptions
  FORMS_SUBMISSIONS: 'submissions', // Subcollection dentro de forms
  EDITIONS: NAMESPACE + 'editions',
  EDITION_STAGES: NAMESPACE + 'edition_stages',
  EDITION_SCHEDULE_MESSAGES: 'schedule_messages',
  EDITION_MESSAGES_SEND: 'sent_messages',
  EDITION_CHAT_GROUPS: 'chat_groups',
  EDITION_CHAT_GROUPS_MESSAGES: 'messages',
  RESERVATION_ITEMS: NAMESPACE + 'reservation_items',
  BOOKINGS: NAMESPACE + 'bookings',
  BOOKINGS_AUDIT: NAMESPACE + 'bookings_audit',
  INSCRIPTION_CHANGE_REQUESTS: NAMESPACE + 'inscription_change_requests',
  PAYMENTS: NAMESPACE + 'payments',
  HOTELS: NAMESPACE + 'hotels',
  FERRYS: NAMESPACE + 'ferrys',
  FACEBOOK_ALBUMS: NAMESPACE + 'facebook_albums',
  FACEBOOK_ALBUMS_PHOTOS: 'photos',
  FACEBOOK_VIDEOS: NAMESPACE + 'facebook_videos',
  FORMS: NAMESPACE + 'forms',
  GUIDES: NAMESPACE + 'guides',
  GUIDES_CATEGORIES: NAMESPACE + 'guides_categories',
  COMMUNITY_FORUM: NAMESPACE + 'community_forum',
  COMMUNITY_FORUM_REPLIES: 'replies',
  COMMUNITY_FORUM_CATEGORIES: NAMESPACE + 'community_forum_categories',
  AI_CHAT_PROMPTS: NAMESPACE + 'ai_chat_prompts',
  ORGANIZERS: NAMESPACE + 'organizers',
  VEHICLES: NAMESPACE + 'vehicles',
  VEHICLES_MAINTENANCES: 'maintenances',
  ROOMING_LIST: NAMESPACE + 'rooming_list',
  TRACKS_GPX: NAMESPACE + 'tracks_gpx',
  TRACKS_GPX_RECORDED: NAMESPACE + 'tracks_gpx_recorded',
  MAP_WAYPOINTS: NAMESPACE + 'map_waypoints',
  MAP_WAYPOINT_FILES: NAMESPACE + 'map_waypoint_files',
  WAYPOINT_TYPES: NAMESPACE + 'waypoint_types',
  BOOKING_LEGAL_TEXTS: NAMESPACE + 'booking_legal_texts',
  CUSTOM_CONCEPTS: NAMESPACE + 'custom_concepts',
};

/** Document ID used to store edition-independent booking legal texts */
export const BOOKING_LEGAL_TEXTS_GLOBAL_DOC_ID = 'global';

export const ENVIRONMENT = new InjectionToken<any>('environment');
